import client from './client'
import type { EventMedia, EventMediaType } from '@/types/eventMedia'

const BASE = '/organizer/events'

export async function listEventMedia(
  eventSlug: string,
  type?: EventMediaType,
): Promise<EventMedia[]> {
  const params: Record<string, string> = {}
  if (type !== undefined) {
    params['type'] = type
  }
  const { data } = await client.get<{ data: EventMedia[] }>(
    `${BASE}/${eventSlug}/media`,
    { params },
  )
  return data.data
}

export async function getEventMedia(
  eventSlug: string,
  mediaId: number,
): Promise<EventMedia> {
  const { data } = await client.get<{ data: EventMedia }>(
    `${BASE}/${eventSlug}/media/${mediaId}`,
  )
  return data.data
}

export async function uploadEventHero(
  eventSlug: string,
  file: File,
  onProgress?: (pct: number) => void,
): Promise<EventMedia> {
  const form = new FormData()
  form.append('image', file)

  const { data } = await client.post<{ data: EventMedia }>(
    `${BASE}/${eventSlug}/media/hero`,
    form,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (event) => {
        if (onProgress && event.total) {
          onProgress(Math.round((event.loaded * 100) / event.total))
        }
      },
    },
  )
  return data.data
}

export async function deleteEventHero(eventSlug: string): Promise<void> {
  await client.delete(`${BASE}/${eventSlug}/media/hero`)
}

export async function uploadEventSignatureImage(
  eventSlug: string,
  file: File,
  onProgress?: (pct: number) => void,
): Promise<EventMedia> {
  const form = new FormData()
  form.append('image', file)

  const { data } = await client.post<{ data: EventMedia }>(
    `${BASE}/${eventSlug}/media/signature`,
    form,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (event) => {
        if (onProgress && event.total) {
          onProgress(Math.round((event.loaded * 100) / event.total))
        }
      },
    },
  )
  return data.data
}

export async function deleteEventSignatureImage(eventSlug: string, mediaId: number): Promise<void> {
  await client.delete(`${BASE}/${eventSlug}/media/signature/${mediaId}`)
}
